'use client';

import ExploreAndCompare from 'src/components/Earn/ExploreAndCompare/ExploreAndCompare';

export default function Page() {
	return <ExploreAndCompare />;
}
